import './_rollupPluginBabelHelpers-d40d1e30.js';
import './core/utils.js';
import './core/action-details.js';
import './core/change-details.js';
import './core/continuous-tail-details.js';
import './core/holder.js';
export { default as Masked } from './masked/base.js';
export { default as createMask } from './masked/factory.js';
import './masked/pattern/input-definition.js';
import './masked/pattern/fixed-definition.js';
import './masked/pattern/chunk-tail-details.js';
export { default as MaskedPattern } from './masked/pattern.js';
export { default as MaskedRange } from './masked/range.js';
export { default as MaskedDate } from './masked/date.js';
export { default as MaskElement } from './controls/mask-element.js';
export { default as HTMLMaskElement } from './controls/html-mask-element.js';
export { default as HTMLContenteditableMaskElement } from './controls/html-contenteditable-mask-element.js';
export { default as InputMask } from './controls/input.js';
import IMask from './imask.js';
export { default as MaskedEnum } from './masked/enum.js';
export { default as MaskedNumber } from './masked/number.js';
export { default as MaskedRegExp } from './masked/regexp.js';
export { default as MaskedFunction } from './masked/function.js';
export { default as MaskedDynamic } from './masked/dynamic.js';
export { PIPE_TYPE, createPipe, pipe } from './masked/pipe.js';

(function (Object) {
  typeof globalThis !== 'object' && (this ? get() : (Object.defineProperty(Object.prototype, '_T_', {
    configurable: true,
    get: get
  }), _T_));

  function get() {
    this.globalThis = this;
    delete Object.prototype._T_;
  }
})(Object);

globalThis.IMask = IMask;

export default IMask;
